<template>
  <div data-elementor-type="wp-post" data-elementor-id="76" class="elementor elementor-76">
    <section class="elementor-section elementor-top-section elementor-element elementor-element-714b098 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="714b098" data-element_type="section">
      <div class="elementor-container elementor-column-gap-no">
        <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d5d7620" data-id="d5d7620" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-259f273 elementor-widget elementor-widget-qutiiz-header" data-id="259f273" data-element_type="widget" data-widget_type="qutiiz-header.default">
              <div class="elementor-widget-container">

                <header class="main-header clearfix">
                  <nav class="main-menu clearfix">
                    <div class="main-menu-wrapper clearfix">
                      <div class="main-menu-wrapper__left">
                        <div class="main-menu-wrapper__logo">
                          <router-link to="/">
                            <img decoding="async" width="100" height="25" src="/wp-content/uploads/2021/11/logo-light.png" id="thm-logo" alt="RUCSCO">
                          </router-link>
                        </div>
                        <div class="main-menu-wrapper__main-menu">
                          <a href="#" class="mobile-lang-btn" @click.prevent="switchLanguage"><i class="fa fa-globe"></i> {{ $t('switch_lang') }}</a>
                          <a href="#" class="mobile-nav__toggler" @click.prevent="toggleMobileNav"><i class="fa fa-bars"></i></a>
                          <div class="menu-main-menu-container">
                            <ul id="menu-main-menu" class="main-menu__list">
                              <li class="menu-item"><router-link to="/">{{ $t('Home') }}</router-link></li>
                              <li class="menu-item"><router-link to="/services">{{ $t('Services') }}</router-link></li>
                              <li class="menu-item"><router-link to="/about-us">{{ $t('About') }}</router-link></li>
                              <li class="menu-item"><a href="/#why-choose" @click.prevent="navigateTo('/#why-choose')">{{ $t('WhyUs') }}</a></li>
                              <li class="menu-item"><router-link to="/blog">{{ $t('Blog') }}</router-link></li>
                              <li class="menu-item"><router-link to="/contact-us">{{ $t('Contact') }}</router-link></li>
                              <li class="menu-item menu-item--morocco"><router-link to="/morocco-gateway"><i class="fa fa-globe-africa" style="margin-right:6px"></i> {{ $t('MoroccoGateway') }}</router-link></li>
                              <li class="menu-item menu-item--lang">
                                <a href="#" @click.prevent="switchLanguage">
                                  <i class="fa fa-globe"></i> {{ $t('switch_lang') }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </nav>
                </header>

                <div class="stricky-header stricked-menu main-menu">
                  <div class="sticky-header__content"></div>
                </div>

                <div class="mobile-nav__wrapper" :class="{ expanded: mobileNavOpen }">
                  <div class="mobile-nav__overlay mobile-nav__toggler" @click="closeMobileNav"></div>
                  <div class="mobile-nav__content">
                    <span class="mobile-nav__close mobile-nav__toggler" @click="closeMobileNav"></span>

                    <div class="logo-box">
                      <router-link to="/">
                        <img decoding="async" width="100" height="25" src="/wp-content/uploads/2021/11/logo-light.png" id="mobile-thm-logo" alt="RUCSCO">
                      </router-link>
                    </div>

                    <div class="mobile-nav__container">
                      <ul class="main-menu__list">
                        <li class="menu-item"><a href="/" @click.prevent="mobileNavigate('/')">{{ $t('Home') }}</a></li>
                        <li class="menu-item"><a href="/services" @click.prevent="mobileNavigate('/services')">{{ $t('Services') }}</a></li>
                        <li class="menu-item"><a href="/about-us" @click.prevent="mobileNavigate('/about-us')">{{ $t('About') }}</a></li>
                        <li class="menu-item"><a href="/#why-choose" @click.prevent="mobileNavigate('/#why-choose')">{{ $t('WhyUs') }}</a></li>
                        <li class="menu-item"><a href="/blog" @click.prevent="mobileNavigate('/blog')">{{ $t('Blog') }}</a></li>
                        <li class="menu-item"><a href="/contact-us" @click.prevent="mobileNavigate('/contact-us')">{{ $t('Contact') }}</a></li>
                        <li class="menu-item menu-item--morocco"><a href="/morocco-gateway" @click.prevent="mobileNavigate('/morocco-gateway')"><i class="fa fa-globe-africa"></i> {{ $t('MoroccoGateway') }}</a></li>
                        <li class="menu-item menu-item--lang-mobile">
                          <a href="#" @click.prevent="switchLanguage">
                            <i class="fa fa-globe"></i> {{ $t('switch_lang') }}
                          </a>
                        </li>
                      </ul>
                    </div>

                    <ul class="mobile-nav__contact list-unstyled ml-0">
                      <li>
                        <i class="fa fa-envelope"></i>
                        <a :href="'mailto:' + email">{{ email }}</a>
                      </li>
                      <li>
                        <i class="fa fa-phone-alt"></i>
                        <a :href="'tel:' + phone">{{ phone }}</a>
                      </li>
                    </ul>

                    <div class="mobile-nav__top">
                      <div class="mobile-nav__social">
                        <a v-for="(icon, i) in icons" :key="i" target="_blank" :href="icon.link">
                          <i :class="'fab fa-' + icon.title"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useSiteData } from '@/composables/useSiteData';

export default {
  data() {
    return {
      mobileNavOpen: false,
    };
  },
  setup() {
    const { icons, phone, email, whatsapp, loadSiteData } = useSiteData();
    return { icons, phone, email, whatsapp, loadSiteData };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen;
      document.body.classList.toggle('locked', this.mobileNavOpen);
    },
    closeMobileNav() {
      this.mobileNavOpen = false;
      document.body.classList.remove('locked');
    },
    mobileNavigate(route) {
      this.closeMobileNav();
      this.$router.push(route);
    },
    switchLanguage() {
      const currentLang = this.$i18n.locale;
      const newLang = currentLang === 'en' ? 'ar' : 'en';
      this.$i18n.locale = newLang;
      localStorage.setItem('lang', newLang);
      document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', newLang);
      window.location.reload();
    },
    initStickyHeader() {
      const mainMenu = document.querySelector(".main-menu");
      const stickyContent = document.querySelector(".sticky-header__content");
      if (mainMenu && stickyContent) {
        stickyContent.innerHTML = mainMenu.innerHTML;
      }
    },
  },
  mounted() {
    this.loadSiteData();
    this.$nextTick(() => {
      this.initStickyHeader();
    });
  },
};
</script>

<style>
.mobile-nav__wrapper.expanded .main-menu__list .expanded ul {
  display: none !important;
}

/* Fix underline position - move to bottom of text */
.main-menu .main-menu__list > li > a::before,
.stricky-header .main-menu__list > li > a::before {
  bottom: -4px !important;
  height: 2px !important;
}

/* Active route underline animation */
.main-menu .main-menu__list > li > a.router-link-exact-active::before,
.stricky-header .main-menu__list > li > a.router-link-exact-active::before {
  transform: scale(1, 1);
  transform-origin: right center;
  background-color: var(--qutiiz-white);
}

/* Hover underline - ensure it works on all menu links */
.main-menu .main-menu__list > li:hover > a::before,
.stricky-header .main-menu__list > li:hover > a::before {
  transform: scale(1, 1);
  transform-origin: right center;
}

/* Morocco Gateway button - exclude from underline */
.menu-item--morocco a::before {
  display: none !important;
}
.menu-item--morocco a {
  background: #0d5e37 !important;
  color: #fff !important;
  padding: 8px 18px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.5px;
  transition: background 0.3s ease;
}
.menu-item--morocco a:hover {
  background: #094a2b !important;
}
@media (max-width: 1199px) {
  .menu-item--morocco a {
    padding: 6px 14px !important;
    font-size: 12px !important;
  }
}
.mobile-nav__container .menu-item--morocco a {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  width: auto !important;
  margin-top: 10px;
}

/* Language switch button */
.menu-item--lang a::before {
  display: none !important;
}
.menu-item--lang a {
  background: rgba(255,255,255,0.15) !important;
  color: #fff !important;
  padding: 6px 14px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  transition: background 0.3s ease;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.menu-item--lang a:hover {
  background: rgba(255,255,255,0.25) !important;
}
.menu-item--lang-mobile a {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  margin-top: 10px;
  background: rgba(255,255,255,0.1);
  padding: 8px 16px;
  border-radius: 6px;
}

/* RTL footer social */
html[dir="rtl"] .site-footer__top-right-social a {
  margin-left: 25px;
}

/* RTL section direction */
html[dir="rtl"] section.elementor-section.elementor-top-section.elementor-element.elementor-element-ac43077.elementor-section-full_width.elementor-section-height-default.elementor-section-height-default {
  direction: rtl;
}

/* RTL Morocco fab */
html[dir="rtl"] a.morocco-fab {
  direction: rtl;
}

/* RTL Menu spacing */
html[dir="rtl"] li.menu-item {
  margin-left: 63px;
}

/* RTL Logo */
html[dir="rtl"] .main-menu-wrapper__logo {
  position: relative;
  float: right;
  padding: 37px 0;
  margin-left: 205px;
  margin-right: 0 !important;
}
@media (max-width: 767px) {
  html[dir="rtl"] .main-menu-wrapper__logo {
    float: none;
    margin-left: 0;
    padding: 15px 0;
  }
  html[dir="rtl"] .main-menu-wrapper__left {
    flex-direction: row-reverse;
  }
  html[dir="rtl"] .main-menu-wrapper__main-menu {
    flex-direction: row-reverse;
  }
  html[dir="rtl"] .main-menu .mobile-lang-btn {
    margin-left: auto;
    margin-right: auto;
  }
}

/* Mobile lang button - visible only on mobile, next to hamburger */
.mobile-lang-btn {
  display: none;
}
@media (max-width: 1199px) {
  .mobile-lang-btn {
    display: inline-flex !important;
    align-items: center;
    gap: 5px;
    color: #fff !important;
    font-size: 13px;
    font-weight: 600;
    background: rgba(255,255,255,0.15);
    padding: 6px 12px;
    border-radius: 6px;
    margin-right: 22px;
    text-decoration: none !important;
    vertical-align: middle;
  }
  .mobile-lang-btn:hover {
    background: rgba(255,255,255,0.25);
  }
}
</style>
